import { useTranslation } from "react-i18next";

export const BNotFound = () => {
  const { t } = useTranslation();

  return <div>{t("YOU_FOUND_A_SECRET_PLACE")}</div>;
};
